exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-tab-panels{position:relative;overflow:hidden}.cube-tab-panels-group{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-transition:all .4s cubic-bezier(.86,0,.07,1);transition:all .4s cubic-bezier(.86,0,.07,1)}", ""]);

// exports
